module.exports = __webpack_public_path__ + "static/contact-segmentation-a32e459da97803994084ecf1fd860399.svg";